module.exports = __webpack_public_path__ + "img/marker-icon-box-warning.4ec0dbed.png";